export default {
  course_title: '02Web - Smart Portal courses',
  course_title_list: '0201Web - Display course list',
  course_watch_course: "0202Web - View course",
  course_category: 'Course Categories',
  course_new: 'By latest',
  course_hot: 'By hottest'
}
